module.exports = __webpack_public_path__ + "static/img/stJohns1.9c62d38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/stJohns1.jpg
// module id = 135
// module chunks = 9